import { Component, Input } from '@angular/core';
import { CatalogSection } from '../../catalog-section.service';

@Component({
  selector: 'catalog-filter-tags',
  templateUrl: './catalog-filter-tags.component.html',
  styleUrls: ['../../../styles/components/hashtags.component.less']
})
export class CatalogFilterTagsComponent {
  @Input() section: CatalogSection;

  constructor() {}

}
